import React, { useContext } from 'react';
import {
  FormPanel,
  ApiFilterOperation,
  UserContext,
  FormAutocomplete,
  FormContext,
  Button,
  useFormSelector,
  DomainObject,
  Filter,
} from '@eas/common-web';
import { dictionaryLabelMapper } from '../../../components/form/mappers/label-mappers';
import { FormPreFilledAutocomplete } from '../../../components/form/pre-filled-autocomplete/pre-filled-autocomplete';
import { HelpLabel } from '../../../components/help/help-label';
import { useSubjects } from '../../subject/subjects-api';
import { SubjectAutocomplete } from '../../../models';
import { Permission, EvidenceUrl } from '../../../enums';

import { useOvzFacilities } from '../../ovz-facility/ovz-facilities-api';

import OpenInNewIcon from '@material-ui/icons/OpenInNew';

export function StepSubjectAndOvzContent() {
  const { hasPermission } = useContext(UserContext);

  const { getFieldValues, setFieldValue } = useContext(FormContext);

  const { operator } = useFormSelector((data: { operator: DomainObject }) => ({
    operator: data.operator,
  }));

  const filters: Filter[] = [
    {
      field: 'withMinimalDistancesSources',
      operation: ApiFilterOperation.EQ,
      value: true,
    },
  ];

  if (operator?.id) {
    filters.push({
      field: 'operator.id',
      operation: ApiFilterOperation.EQ,
      value: operator?.id,
    });
  }

  const ovzFacilities = useOvzFacilities({
    filters,
  });

  const subjectSource = useSubjects(
    hasPermission(Permission.MinimalDistances.MINIMAL_DISTANCES_CREATE_ALL)
      ? undefined
      : {
          filters: [
            {
              operation: ApiFilterOperation.CUSTOM,
              customJsonModel: JSON.stringify({
                operation: 'HAS_SUBJECT_PERMISSION',
                permissions: [
                  Permission.MinimalDistances.MINIMAL_DISTANCES_CREATE_OWN,
                ],
                includeEmpowered: true,
              }),
            },
          ],
        }
  );

  return (
    <FormPanel label="Vyplňte">
      <FormPreFilledAutocomplete<SubjectAutocomplete>
        name="operator"
        label={
          <HelpLabel
            label="Provozovatel OVZ"
            code="MINIMAL_DISTANCES_NEW_OPERATOR"
            required
          />
        }
        source={subjectSource}
        tooltipMapper={dictionaryLabelMapper}
        labelMapper={dictionaryLabelMapper}
        notifyChange={() => {
          setFieldValue('ovzFacility', undefined);
        }}
        after={
          <>
            {operator?.id && (
              <Button
                onClick={() => {
                  window.open(
                    `${EvidenceUrl.SUBJECTS}/${operator.id}?mod=form`,
                    '_blank'
                  );
                }}
                label={<OpenInNewIcon fontSize="small" color="primary" />}
              />
            )}
          </>
        }
      />

      <FormAutocomplete
        name="ovzFacility"
        disabled={!operator?.id}
        after={
          <>
            {getFieldValues().ovzFacility?.id && (
              <Button
                onClick={() => {
                  window.open(
                    `${EvidenceUrl.OVZ_FACILITIES}/${
                      getFieldValues().ovzFacility?.id
                    }?mod=form`,
                    '_blank'
                  );
                }}
                label={<OpenInNewIcon fontSize="small" color="primary" />}
              />
            )}
          </>
        }
        label={
          <HelpLabel
            label="Provozovna OVZ"
            code="MINIMAL_DISTANCES_OVZ_FACILITY"
            required
          />
        }
        source={ovzFacilities}
        tooltipMapper={dictionaryLabelMapper}
        labelMapper={dictionaryLabelMapper}
      />
    </FormPanel>
  );
}
